const initSlider = () => {
	const sliders = document.querySelectorAll('.slider'),
		  breakpoint = window.matchMedia('(min-width: 768px)');


	sliders.forEach(slider => {
		if (slider.querySelector('.slider-swiper')) {
			const sectionSwiper = slider.querySelector('.slider-swiper').className.split(' ')[1];
			let swiper;
	
			const initSwiper = () => {
				swiper = new Swiper(`.${sectionSwiper}`, {
					slidesPerView: 'auto',
					grabCursor: true,
					slideToClickedSlide: true,
					loop: true
				});
			};
	
			const breakpointChecker = () => {
				if (breakpoint.matches === true) {
					initSwiper();
				} else {
					if (swiper !== undefined) {
						swiper.destroy();
					}
	
					return;
				}
			}
	
			breakpoint.addEventListener("change", breakpointChecker);
			breakpointChecker();
		}
	});
}

window.addEventListener('DOMContentLoaded', () => {
	initSlider();
});